import React, { useEffect, useState } from 'react'
import { isMac, verifyShortcut } from '../../../Components/action/utilities';
import TaskSearchModal from './TaskSearchModal';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const GlobalTaskSearchModal = () => {
    const [taskSearchModal, setTaskSearchModal] = useState(false);
    const navigate = useNavigate();
    const settings = useSelector(state => state.settings.settings);

    useEffect(() => {
        document.removeEventListener('keydown', onPressCmd, false);
        document.addEventListener('keydown', onPressCmd, false);
    
        return () => {
          document.removeEventListener('keydown', onPressCmd, false);
        }
    }, [settings]);

    const hideModal = () => {
        setTaskSearchModal(false);
        navigate(process.env.REACT_APP_ROOT);
    }

    const onPressCmd = (e) => {
        if(typeof settings.keyboardShortcuts == 'undefined' || settings?.keyboardShortcuts?.searchTask?.length > 0){
            const shortcut = settings?.keyboardShortcuts?.searchTask?.length > 0 ? settings?.keyboardShortcuts?.searchTask.join(' ') : (isMac ? 'Cmd' : 'Ctrl') + ' K';

            // Check if either meta (Cmd) or ctrl is pressed, and the 'K' key is pressed
            if(verifyShortcut(shortcut, e)){
                e.preventDefault();  // Prevent default browser behavior
                e.stopPropagation();  // Stop event propagation to prevent focusing the address bar
                setTaskSearchModal(true);  // Open the popup/modal
            }
        }
    }

    return (
        taskSearchModal && <TaskSearchModal onHide={hideModal} />
    )
}

export default GlobalTaskSearchModal